// extracted by mini-css-extract-plugin
export default {"cancelTicket":"button_cancelTicket__E+APO","button":"button_button__UQ77E"};